import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../apiConfig';

export const sendOtp = createAsyncThunk(
  'user/sendOtp',
  async ({ phone }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/otp/send/?phone=${encodeURIComponent(phone)}`,
        null,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      console.log("API response:", response.data);
      
      // Return the successful response
      return response.data; 
      
    } catch (error) {
      if (error.response) {
        if (error.response.status === 429) {
          console.log("Rate limiting error:", error.response);
          return rejectWithValue({
            message: 'OTP request limit reached. Please try again after 30 minutes.'
          });
        }

        console.log("Server response error:", error.response);
        return rejectWithValue({
          message: 'Error: We are working on it, please try again later.'
        });
      }
      
      else if (error.request) {
        console.log("No response from server:", error.request);
        return rejectWithValue({ message: 'No response from server.' });
      }
      
      else {
        console.log("Request setup error:", error.message);
        return rejectWithValue({
          message: 'Error: We are working on it, please try again later.'
        });
      }
    }
  }
);



// Verify OTP thunk
export const verifyOtp = createAsyncThunk(
  'user/verifyOtp',
  async ({ number, otp }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}otp/verify/?number=${encodeURIComponent(number)}&otp=${encodeURIComponent(otp)}`,
        null,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        // Server responded with an error
        return rejectWithValue(error.response.data);
      } else if (error.request) {
        // No response from the server
        return rejectWithValue({ message: 'No response from server.' });
      } else {
        // Error setting up the request
        return rejectWithValue({ message: error.message });
      }
    }
  }
);

// Redux slice
const otpSlice = createSlice({
  name: 'otpSlice',
  initialState: {
    otp: null,
    loading: false,
    error: null,
    verificationStatus: null, 
  },
  reducers: {
    resetOtp: (state) => {
      state.otp = null;
      state.verificationStatus = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.verificationStatus = 'pending'; // Show a "loading" message
      })
      .addCase(sendOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.otp = action.payload.otp;
        state.verificationStatus = 'success'; // OTP sent successfully
        state.error = null;
      })
      .addCase(sendOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
        state.verificationStatus = 'failed'; // OTP sending failed
      })
      .addCase(verifyOtp.pending, (state) => {
        state.loading = true;
        state.verificationStatus = 'pending'; // Verification in progress
        state.error = null;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.verificationStatus = 'success'; // OTP verified successfully
        state.error = null;
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
        state.verificationStatus = 'failed'; // OTP verification failed
      });
  },
});

export const { resetOtp } = otpSlice.actions;

export default otpSlice.reducer;
